import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'plan_report',
    label: 'PlanReport',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
